import $ from "jquery";

function getSearchScope($from) {
  // внутри drawer
  const $scope = $from.closest("[data-search-scope]");
  if ($scope.length) return $scope;

  // desktop (подстрой селектор под свой блок в хедере)
  return $(".header__search").length ? $(".header__search") : $(document.body);
}

function buildSearchUrl(targetKey, queryText) {
  const q = (queryText || "").trim();
  if (!q) return null;

  const encoded = encodeURIComponent(`%${q}%`);
  const ifWorkshop = targetKey === "workshops" ? "&filter[or]=true" : "";

  return `/watch/${targetKey}/?filter[*name]=${encoded}${ifWorkshop}`;
}

function submitSearch($scope) {
  // тип (workshops/orders) — для drawer из hidden, для desktop из твоего dropdown
  const targetKey =
    $scope.find(".js-search-target").val() ||
    $scope.find(".js-search-type.is-active").data("key") ||
    $(".header__search-dropdown-title span").data("key") ||
    "workshops";

  const $input = $scope.find('input[name="search"]').first();
  const url = buildSearchUrl(targetKey, $input.val());

  if (!url) return;
  window.location.href = url;
}

// ENTER в любом поисковом инпуте (и drawer, и desktop)
$(document).on("keydown", 'input[name="search"]', function (e) {
  if (e.key === "Enter") {
    e.preventDefault();
    submitSearch(getSearchScope($(this)));
  }
});

// ✅ Клик ТОЛЬКО по кнопке поиска (не по .loupe)
$(document).on("click", ".js-search-submit", function (e) {
  e.preventDefault();
  submitSearch(getSearchScope($(this)));
});

// переключатель типа внутри drawer
$(document).on("click", "[data-search-scope] .js-search-type", function () {
  const $btn = $(this);
  const $scope = $btn.closest("[data-search-scope]");
  const key = $btn.data("key");

  $scope.find(".js-search-type").removeClass("is-active success").addClass("regular");
  $btn.addClass("is-active success").removeClass("regular");
  $scope.find(".js-search-target").val(key);
});

// фокус при открытии drawer
document.addEventListener("shown.bs.offcanvas", function (e) {
  if (e.target?.id === "searchDrawer") {
    e.target.querySelector('input[name="search"]')?.focus();
  }
});
